import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SuggestedRecipientsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SuggestedRecipientsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const suggestedRecipients = (request: SuggestedRecipientsRequest, options?: CashRequestOptions) =>
  post<SuggestedRecipientsRequest, SuggestedRecipientsResponse>('/2.0/cash/suggested-recipients', request, {
    ...options,
    rejectOnError: true,
  })
